var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 40,
    viewBox: "0 0 58 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payment method icon"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "visa-logo",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9171 26.4304H14.4842L11.9099 16.3206C11.7877 15.8556 11.5283 15.4444 11.1467 15.2507C10.1943 14.7637 9.14486 14.3762 8 14.1807V13.7915H13.5301C14.2934 13.7915 14.8658 14.3762 14.9612 15.0552L16.2969 22.3477L19.7281 13.7915H23.0656L17.9171 26.4304ZM24.9737 26.4304H21.7316L24.4013 13.7915H27.6434L24.9737 26.4304ZM31.8378 17.2929C31.9332 16.6121 32.5057 16.2229 33.1735 16.2229C34.223 16.1252 35.3661 16.3206 36.3202 16.8059L36.8926 14.0847C35.9386 13.6955 34.8891 13.5 33.9367 13.5C30.7901 13.5 28.5003 15.2507 28.5003 17.6804C28.5003 19.5288 30.1222 20.4993 31.2671 21.084C32.5057 21.667 32.9827 22.0563 32.8873 22.6393C32.8873 23.5137 31.9332 23.903 30.9809 23.903C29.836 23.903 28.6911 23.6115 27.6434 23.1245L27.0709 25.8474C28.2158 26.3327 29.4544 26.5281 30.5992 26.5281C34.1276 26.6242 36.3202 24.8752 36.3202 22.25C36.3202 18.9441 31.8378 18.7504 31.8378 17.2929ZM47.6667 26.4304L45.0924 13.7915H42.3273C41.7549 13.7915 41.1825 14.1807 40.9917 14.7637L36.2248 26.4304H39.5623L40.2284 24.5837H44.3292L44.7108 26.4304H47.6667ZM42.8044 17.1951L43.7567 21.9585H41.0871L42.8044 17.1951Z",
    fill: "#172B85"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57,
    height: 39,
    rx: 5.5,
    stroke: "#F2F4F7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.fdde2de69c3f37fe84a8facb80edf6ca.svg";
export { ForwardRef as ReactComponent };